import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const joinWaitlist = async (payload) => {
  const { data } = await api.post("/waitlist", payload);
  return data;
};

export const getWaitlistStats = async () => {
  const { data } = await api.get("/waitlist/stats");
  return data;
};

export const submitContact = async (payload) => {
  const { data } = await api.post("/contact", payload);
  return data;
};
